import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      {isVisible && <button onClick={scrollToTop} className="fixed bottom-8 right-8 p-3 bg-black/20 hover:bg-black/30 backdrop-blur-sm text-white rounded-full transition-all duration-300 z-10" aria-label="Scroll to top" data-id="element-310">
          <ArrowUpIcon className="h-6 w-6" data-id="element-311" />
        </button>}
    </>;
};